import React, { useState } from 'react';
import { userAtom } from '../atoms/userAtom';
import { useAtomValue, useSetAtom } from 'jotai';
import { Button, Paper, Stack, TextField, Typography } from '@mui/material';
import { Api } from '../providers/Api';

const Login = () => {
    const user = useAtomValue(userAtom);
    const setUser = useSetAtom(userAtom);
    const [pin, setPin] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async () => {
        let api = new Api();
        const loggedIn = await api.login(pin);
        if (!loggedIn || !loggedIn.user) {
            setError("Wrong username or password");
        }
        else {
            setUser({ id: loggedIn.user, loggedIn: true, role: loggedIn.role });
        }
    }

    return <Paper style={{ padding: 10 }}>
        <div style={{width: 300, margin:'auto'}}>
        <Typography>Login to Target#</Typography>
        <Stack direction={"row"} spacing={2}>
            <TextField placeholder='User name' value={pin} onChange={(ev) => { setPin(ev.target.value) }} fullWidth />
            {error && <Typography variant='body2' style={{ color: '#F00' }}>{error}</Typography>}
            <Button variant='contained' onClick={handleLogin}>Login</Button>
        </Stack>
        </div>
    </Paper>;
}

export default Login;